import _Object$keys from 'babel-runtime/core-js/object/keys';
import Vue from 'vue';
import Router from 'vue-router';
import NewPolicyMenu from '@/components/new/NewPolicyMenu';
import NewPolicy from '@/components/new/NewPolicy';
import CasesSearch from '@/components/cases/CasesSearch';
import PolicyCase from '@/components/case/PolicyCase';
import AdminView from '@/components/admin/AdminView';
import Import from '@/components/import/Import';
import JobDetails from '@/components/job/JobDetails';
import BatchManagement from '@/components/batch/BatchManagement';
import ActionsOverview from '@/components/action/ActionsOverview';
import UserManagement from '@/components/admin/UserManagement';
import ConfigurationManagement from '@/components/admin/ConfigurationManagement';
import FormManagement from '@/components/admin/FormManagement';
import TransformationFilesView from '@/components/admin/TransformationFilesView';
import BusinessRulesView from '@/components/admin/BusinessRulesView';
import CustomersSearch from '@/components/customers/CustomersSearch';
import CustomerDetails from '@/components/customer/CustomerDetails';
import Admin from '@/components/admin/Admin';
import BaseTableManagement from '@/components/admin/BaseTableManagement';
import PdfTemplateManagement from '@/components/admin/PdfTemplateManagement';
import ChartsPlaceholder from '@/components/analyse/ChartsPlaceholder';
import HomePlaceholder from '@/components/HomePlaceholder';
import KeycloakService from '../service/keycloak/KeycloakService';
import { genericServerErrorStore } from '../service/GenericServerErrorStore';
import Export from '@/components/export/Export';
import { PageRoles } from '@/service/keycloak/PageRoles';
import NotFound from '../components/NotFound';
import logger from 'js-logger';

Vue.use(Router);

export var router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    component: HomePlaceholder
  }, {
    path: '/new',
    name: 'Nieuw',
    component: NewPolicyMenu,
    meta: { rolesAllowed: PageRoles.NEW }
  }, {
    path: '/new/hearingAid',
    redirect: '/new/liability',
    meta: { rolesAllowed: PageRoles.NEW }
  }, {
    path: '/new/:policyType',
    component: NewPolicy,
    props: function props(route) {
      return {
        policyType: route.params.policyType,
        customerUniqueId: route.query.customerUniqueId
      };
    },
    meta: { rolesAllowed: PageRoles.NEW }
  }, {
    path: '/cases',
    component: CasesSearch,
    props: function props(route) {
      return route.query || {
        status: 'all'
      };
    },

    meta: { rolesAllowed: PageRoles.CASES }
  }, {
    path: '/case/:caseHeaderId',
    component: PolicyCase,
    props: function props(route) {
      return {
        isPrimaryRoute: true,
        caseHeaderId: route.params.caseHeaderId
      };
    },
    meta: { rolesAllowed: PageRoles.CASES }
  }, {
    path: '/case/:caseHeaderId/:historicalPolicycaseId',
    component: PolicyCase,
    props: function props(route) {
      return {
        isPrimaryRoute: true,
        caseHeaderId: route.params.caseHeaderId,
        historicalPolicycaseId: route.params.historicalPolicycaseId
      };
    },
    meta: { rolesAllowed: PageRoles.IMPORT }
  }, {
    path: '/export',
    component: Export,
    meta: { rolesAllowed: PageRoles.EXPORT }
  }, {
    path: '/import',
    meta: { rolesAllowed: PageRoles.IMPORT },
    component: Import
  }, {
    path: '/job/:jobId',
    component: JobDetails,
    props: true,
    meta: { rolesAllowed: PageRoles.IMPORT }
  }, {
    path: '/batch',
    component: BatchManagement,
    meta: { rolesAllowed: PageRoles.BATCH }
  }, {
    path: '/action',
    component: ActionsOverview,
    props: function props(route) {
      return route.query;
    },

    meta: { rolesAllowed: PageRoles.ACTION }
  }, {
    path: '/customer',
    component: CustomersSearch,
    props: function props(route) {
      return route.query;
    },

    meta: { rolesAllowed: PageRoles.CUSTOMER }
  }, {
    path: '/customer/:customerId',
    component: CustomerDetails,
    props: true,
    meta: { rolesAllowed: PageRoles.CUSTOMER }
  }, {
    path: '/admin',
    component: Admin,
    meta: { rolesAllowed: PageRoles.ADMIN },
    children: [{
      path: '',
      component: AdminView
    }, {
      path: 'usersManagement',
      component: UserManagement,
      props: function props(route) {
        return route.query;
      }
    }, {
      path: 'configurationManagement',
      component: ConfigurationManagement
    }, {
      path: 'form-builder',
      component: FormManagement
    }, {
      path: 'transformationFiles',
      component: TransformationFilesView
    }, {
      path: 'businessRules',
      component: BusinessRulesView
    }, {
      path: 'baseTables',
      component: BaseTableManagement
    }, {
      path: 'pdfTemplates',
      component: PdfTemplateManagement
    }]
  }, {
    path: '/analyse',
    component: ChartsPlaceholder,
    meta: { rolesAllowed: PageRoles.ANALYSE }
  }, { path: '/404', component: NotFound },
  // Using the following redirect, we have the same user experience as if we try to open unauthorized route and redirected to /404 (see the global router.beforeEach below).
  { path: '*',
    redirect: function redirect(to) {
      logger.error('URL was not found. Redirecting to 404 NotFound.'); // Log it before we lose the originally requested url.
      return '/404';
    }
  }]
});
window.addEventListener('storage', function (event) {
  if (event.key === 'logout') {
    location.reload(); // reload the page to enforce logout
  }
});
function logout() {
  // Perform logout actions such as clearing session, tokens, etc.
  // Then trigger the logout event
  localStorage.setItem('logout', Date.now());
}
/**
 * A guard which before each router transition checks if the user has all roles needed for each step of the path
 * in order for the transition to be allowed
 * All authenticated users are allowed to go to the 404 page
 *
 * ADDITIONALLY:
 * When no preference is set, the router should redirect to the default starting screen.
 * When that screen is not available due to lack of roles, the router should redirect
 * to the first screen available.
 */
router.beforeEach(function (to, from, next) {
  var userAllowedToProceed = false;
  if (KeycloakService.canActivate() && KeycloakService.isAdmin()) {
    userAllowedToProceed = true;
  } else if (to.path === '/404' || KeycloakService.canActivate()) {
    // traversing all steps of the path we are moving onto
    for (var i = 0; i < to.matched.length; i++) {
      if (_Object$keys(to.matched[i].meta).length === 0 || KeycloakService.isRoleBasedAccessAllowed(to.matched[i].meta.rolesAllowed)) {
        userAllowedToProceed = true;
      } else {
        userAllowedToProceed = false;
        break;
      }
    }
  }
  if (userAllowedToProceed) {
    // clearing all generic errors on page transition
    genericServerErrorStore.state.setGlobalError(false);
    next();
  } else {
    if (KeycloakService.authenticated()) {
      logger.error('URL was not found. Redirecting to 404 NotFound.'); // this should sounds like normal 404 log
      next('/404');
    } else {
      logout();
      next(false);
    }
  }
});


// WEBPACK FOOTER //
// ./src/router/index.js